<template>
  <div class="container stadisticsZone">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack()">
        <i class="mdi mdi-chevron-left"></i>
      </span>

      {{ device.data.name }}
    </h1>

    <statistics :currency="installation.currency" v-if="isLoaded"></statistics>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Statistics from "../../../../components/shared/Statistics";

export default {
  components: { Statistics },
  name: "device-statistics",
  props: {
    id: String,
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    ...mapState("devices", {
      device: "current",
    }),
  },
  methods: {
    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/device/" +
          this.device.serialnumber
      );
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      setDevice: "setCurrent",
      setStatistics: "setStatistics",
    }),
  },
  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        this.setZone(this.$route.params.idZone).then(() =>
          this.setDevice(this.$route.params.idDevice).then(() => {
            this.isLoaded = true;
          })
        );
      })
      .catch(() => {
        //this.$router.push('/installations');
      });
  },
};
</script>

<style lang="scss" scoped>
h1.title {
  margin: 3rem 0 5rem;
  text-align: left;
}
.container {
  max-width: 100%;
}
.stadisticsZone {
  padding: 0 2rem 2rem;
}
</style>
